<template>
  <div v-loading="loading">
    <strong style="padding-top: 30px">游戏其他相关配置：</strong>
    <div class="list">
      <div class="list-item">
        <span class="list-text">保险返利开关</span>
        <el-switch
            :value="functionList.openInsurance"
            active-text="开启"
            inactive-text="关闭"
            :active-value="0"
            :inactive-value="1"
            @change="openInsurance($event)"/>
      </div>
      <div class="list-item">
        <span class="list-text">抽水方式</span>
        <el-switch
            v-model="functionList.pumpingMode"
            active-text="获胜玩家筹码抽取"
            inactive-text="有效池抽取"
            :active-value="1"
            :inactive-value="0"
            @change="updatePumpingMode($event)"/>
      </div>
      <div  class="list-item">
        分发最低限额：
        <el-input-number
            v-model="functionList.number"
            controls-position="right"
            :min="100"
            :max="10000000">
        </el-input-number>
        <el-button type="primary" icon="el-icon-edit" @click="updateNumber(functionList.number)" size="mini"></el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapState} from 'vuex'

export default {
  data(){
    return{
      loading:false,
      functionList:{
        openInsurance:null,
        number:null,
        pumpingMode: null
      }
    }
  },
  computed: {
    firstList(){
      return this.functionList;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    ...mapState('login', ['permissions']),
    ...mapActions('gameConfigure', ['getGameConfigure', 'updateInsurance', 'updateLimt','updatePumpingModeApi']),
    getList(){
      this.loading = true;
      this.getGameConfigure().then((res)=>{
        this.functionList.openInsurance=res.data.insurance;
        this.functionList.number=res.data.number;
        this.functionList.pumpingMode=res.data.pumpingMode;
        this.loading = false;
      })
    },
    updateNumber(value) {
      console.log(value)
      this.updateLimt(value).then(() => {
        this.$message.success('修改成功');
      })
    },
    openInsurance(value) {
      this.$confirm(`您确定要更改保险返利功能状态吗？`, '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.updateInsurance(value).then(() => {
          this.$message.success('修改成功')
          this.getList();
        })
      }).catch(() => {
      })

    },
    updatePumpingMode(value) {
      this.$confirm(`您确定要更改抽水方式吗？`, '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.updatePumpingModeApi(value).then(() => {
          this.$message.success('修改成功')
          this.getList();
        })
      }).catch(() => {
      })

    }
  }
}
</script>
<style lang="scss" scoped>
.block {
  height: 40px;
  line-height: 40px;
  font-weight: bold;
}

.list {
  flex: 1;
  margin-top: 10px;
  padding: 0 0 30px 50px;
  background-color: $bg-color;
  border-radius: 5px;
  &-text {
    padding-right: 100px;
  }
  &-item {
    display: inline-block;
    height: 50px;
    padding: 0 30px;
    margin-top: 30px;
    margin-right: 50px;
    line-height: 50px;
    text-align: right;
    background-color: #fff;
    border-radius: 5px;
  }
}
</style>